let host = null

export function bindAuthPopupHost (instance) {
  host = instance
}

export function unbindAuthPopupHost (instance) {
  if (host === instance) {
    host = null
  }
}

export const authPopup = {
  open (url, options = {}) {
    if (!host) {
      return null
    }
    return host.open(url, options)
  },
  close (index) {
    if (host) {
      host.close(index)
    }
  }
}

export default {
  install (Vue) {
    Vue.prototype.$authPopup = authPopup
  }
}
